export default __webpack_public_path__ + "static/media/defaultBrandLogo.77db2bad.svg";